var dataModel = {
  1: {
    'apiEndpoint': 'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2590',
    'prodName': 'Smirnoff Raspberry CRUSH', 
    'abv': '4.3% ABV',
    'active': true,
    'retailers': {},
    'ui': {
      'retailers': {
        1: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2590',
          'bgColor': '#f00091'
        },
        2: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2589',
          'bgColor': '#fab80e'
        }, 
        3: {
          'endpoint':'https://api.channelsight.com/api/2.5/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=4068',
          'bgColor': '#422a80'
        }, 
        4: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2588',
          'bgColor': '#bc0e2d'
        },
      },
      'middle': {
        'color': '#f00091'
      }
    }
  },
  2: {
    'apiEndpoint': 'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2589',
    'prodName': 'Smirnoff Mango & Passionfruit Twist', 
    'abv': '0.0% ABV',
    'active': true,
    'classes': '',
    'dataProductSku': '761052, 757645, 714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797',
    'retailers': {},
    'ui': {
      'retailers': {
        1: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2590',
          'bgColor': '#f00091'
        },
        2: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2589',
          'bgColor': '#fab80e'
        }, 
        3: {
          'endpoint':'https://api.channelsight.com/api/2.5/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=4068',
          'bgColor': '#422a80'
        }, 
        4: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2588',
          'bgColor': '#bc0e2d'
        },
      },
      'middle': {
        'color': '#fab80e',
      }
    }
  },
  3: {
    'apiEndpoint': 'https://api.channelsight.com/api/2.5/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=4068',
    'prodName': 'Smirnoff Berry Burst', 
    'abv': '4.3% ABV',
    'active': false,
    'classes': 'display--none',
    'retailers': {},
    'ui': {
      'retailers': {
        1: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2590',
          'bgColor': '#f00091'
        },
        2: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2589',
          'bgColor': '#fab80e'
        }, 
        3: {
          'endpoint':'https://api.channelsight.com/api/2.5/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=4068',
          'bgColor': '#422a80'
        }, 
        4: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2588',
          'bgColor': '#bc0e2d'
        },
      },
      'middle': {
        'color': '#422a80'
      }
    }
  }, 
  4: {
    'apiEndpoint': 'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2588',
    'prodName': 'Smirnoff No. 21', 
    'abv': '4.3% ABV',
    'active': true,
    'retailers': {},
    'ui': {
      'retailers': {
        1: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2590',
          'bgColor': '#f00091'
        },
        2: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2589',
          'bgColor': '#fab80e'
        }, 
        3: {
          'endpoint':'https://api.channelsight.com/api/2.5/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=4068',
          'bgColor': '#422a80'
        }, 
        4: {
          'endpoint':'https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2588',
          'bgColor': '#bc0e2d'
        },
      },
      'middle': {
        'color': '#bc0e2d'
      }
    }
  }
}


export { dataModel as default };